import boundary from './settings-boundary-en'
import workflow from './settings-workflow-en'

/** Settings -> Planning (plan E). `title` and `subtitle` are plan A's placeholder strings, kept as they were. */
export default {
  title: 'Planning settings',
  subtitle: 'Configuration for the Planning module will appear here.',
  description: 'Plan types, coordinate system, officer groups, the map register and upload limits for Planning.',
  profiles: 'Plan types',
  profilesHint: 'Officers can choose only enabled plan types.',
  profilesRequired: 'Enable at least one plan type.',
  defaultCrs: 'Default coordinate system',
  roles: 'Officer groups',
  reviewerGroups: 'Reviewer groups',
  reviewerHint: 'Members with the admin or publisher role can create, return and retry submissions.',
  approverGroups: 'Approver groups',
  approverHint: 'Members with the admin or publisher role can also approve and delete.',
  noGroups: 'No groups exist yet. Create them in Settings → Groups.',
  unknownGroup: 'Unknown or deleted group ({{id}}). Untick it to remove it.',
  loadingGroups: 'Loading groups…',
  separation: 'Require a different approver',
  separationHint: 'The approver of a revision must not be the person who submitted it.',
  register: 'Map register server',
  registerHint: 'The PostgreSQL server that holds the staging and approved planning layers.',
  registerManaged: "Managed automatically: this tenant's planning layers live in its managed database.",
  registerNone: 'Not configured',
  registerLocked: 'Locked: submissions already exist on this server.',
  ...boundary,
  selfRegistrationSection: 'Applicant accounts',
  selfRegistration: 'Allow applicants to register themselves',
  selfRegistrationHint:
    'Consultants can ask for an applicant account on a public page. Each request waits for approval, and a seat is used only when it is approved.',
  selfRegistrationLink: 'Public registration page',
  selfRegistrationLinkHint: 'Share this link with consultants. It accepts requests once this setting is saved.',
  selfRegistrationCopy: 'Copy link',
  selfRegistrationCopied: 'Copied',
  allowApproverProvisioning: 'Let approver officers approve registrations',
  allowApproverProvisioningHint:
    'Otherwise only tenant administrators can approve applicant registrations. Officers who are only reviewers never can.',
  allowApproverProvisioningWarning:
    'Each approval uses a paid viewer seat. With this on, approver officers can spend seats without an administrator.',
  maxUpload: 'Maximum upload size (MB)',
  maxUploadHint: 'Between 1 and 200 MB.',
  maxUploadInvalid: 'Enter a whole number between 1 and 200.',
  save: 'Save',
  saving: 'Saving…',
  saved: 'Settings saved.',
  workflow,
  /** Planning Phase 5 (plan Task 11, D-634, D-714): the AI drawing clean-up switch, its caps and its AI route. */
  cleanup: {
    title: 'AI drawing clean-up',
    enabled: 'Let consultants clean up a failing drawing with AI before they submit',
    note: 'Off by default. The council pays for the AI. Consultants never see a credit.',
    noteOnprem: "Off by default. The clean-up uses the council's own AI key or a local model.",
    capDrawing: 'Credit limit per drawing (4 to 200)',
    capMonth: 'Credit limit per consultant per month (4 to 2,000)',
    capDrawingInvalid: 'Enter a whole number of credits from 4 to 200.',
    capMonthInvalid: 'Enter a whole number of credits from 4 to 2,000.',
    provider: 'AI provider',
    model: 'Model',
    modelTypedHint: "Leave it empty to use the provider's default model.",
    region: 'Bedrock region',
    regionName: { 'ap-southeast-1': 'Singapore', 'us-east-1': 'US East', 'ap-southeast-5': 'Malaysia' },
    regionOption: '{{name}} ({{region}})',
    where: 'Drawing summaries are {{where}}.',
    keysNote: 'The keys for this provider are set in Settings → Utilities.',
    noKey: 'No key for {{provider}} is set in Settings → Utilities, so the clean-up cannot be turned on.',
    routeUnavailable: 'The AI choice saved here is no longer offered. Choose a provider and a model.',
    chooseRoute: 'Choose…',
  },
} as const
